module.exports = __webpack_public_path__ + "img/favorite-white.d6ec25f5.svg";